var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIrp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.94,
    height: 9.016,
    viewBox: "0 0 7.94 9.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M614.694,426.336v4.144a1.364,1.364,0,0,1-1.352,1.374h-5.236a1.364,1.364,0,0,1-1.353-1.374v-5.448a1.3,1.3,0,0,1,1.288-1.241h.441v-.614a.34.34,0,0,1,.68,0v.61h3.1v-.61a.34.34,0,0,1,.68,0v.611h.441a1.3,1.3,0,0,1,1.315,1.243v1.305h0Zm-.588,0h-6.763v4.146a.77.77,0,0,0,.763.776h5.236a.77.77,0,0,0,.763-.776v-4.146Z",
    transform: "translate(-606.754 -422.837)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.037 4.285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M616.543,437.206v.387h-1.551v-.387h.549v-1.512c0-.033,0-.067,0-.1s0-.069.006-.1l-.362.3a.192.192,0,0,1-.074.036.169.169,0,0,1-.069,0,.163.163,0,0,1-.057-.023.157.157,0,0,1-.038-.033l-.166-.223.849-.72h.433v2.379Z",
    transform: "translate(-614.783 -434.827)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIrp);
export default __webpack_public_path__ + "static/media/icon-irp.60cfec4a.svg";
export { ForwardRef as ReactComponent };